import { pushEventAndTrack } from '../helpers/taggingSerializer'

const buildTracker = (eventName, eventAction, attributes) => () => {
  const eventInfo = { eventName, eventAction }
  const event = { eventInfo, ...(attributes ? { attributes } : {}) }
  pushEventAndTrack(event)
}

const trackClickQuantityStickyBar = buildTracker('pdp_quantityDropdownStickyBar', 'Click Quantity Dropdown Sticky Bar')

const trackBundleInView = options => buildTracker('pdpBundle_enterViewport', 'PDP Bundle Enter Viewport', options)()

export { buildTracker, trackClickQuantityStickyBar, trackBundleInView }
